import { InputBase, makeStyles, Paper } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import i18n from 'i18n';
import React from 'react';
import styles from './styles';

interface SearchBarProps {
  id: string;
  isLoading: boolean;
  placeholder?: string;
  searchValue?: string;
  defaultValue?: string | null;
  handleSearch: (search?: string | undefined) => void;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  onSearchComplete?: () => void;
  overrideClasses?: any;
}

export const SearchBar = ({
  id,
  isLoading,
  placeholder,
  searchValue,
  defaultValue,
  handleSearch,
  setSearchValue,
  onSearchComplete,
  overrideClasses,
}: SearchBarProps) => {
  const classes = makeStyles(styles(overrideClasses))();
  const [isSearchLocked, setIsSearchLocked] = React.useState(false);

  const initiateSearch = () => {
    if (isSearchLocked || isLoading) return;
    setIsSearchLocked(true);

    handleSearch(searchValue || undefined);

    if (onSearchComplete) {
      onSearchComplete();
    }

    setTimeout(() => {
      setIsSearchLocked(false);
    }, 150);
  };

  return (
    <Paper component="form" className={classes.search}>
      <SearchIcon className={classes.searchIcon} />
      <InputBase
        id={id}
        className={classes.searchInput}
        autoFocus
        defaultValue={defaultValue}
        placeholder={placeholder || i18n.t('SEARCH_KEY')}
        onChange={({ target }) => {
          setSearchValue(target.value);
        }}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            initiateSearch();
          }
        }}
      />
    </Paper>
  );
};
